import Input from "./Input";

// src/components/ui/NumberInput.js
export default function NumberInput(props) {
  return <Input {...props} type="number" step="any" />;
}
